export enum StatusConsulta {
  PROCESSANDO = 0,
  REVISAR = 1,
  RECUSADA = 2,
  APROVADA = 3,
}
